import { render, staticRenderFns } from "./AddProblemModal.vue?vue&type=template&id=ff07274e&scoped=true"
import script from "./AddProblemModal.vue?vue&type=script&lang=js"
export * from "./AddProblemModal.vue?vue&type=script&lang=js"
import style0 from "./AddProblemModal.vue?vue&type=style&index=0&id=ff07274e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff07274e",
  null
  
)

export default component.exports